import { useFormSaveStore } from './FormSaveStore'
window.addEventListener('beforeunload', function (e) {
    const state = useFormSaveStore.getState()
    const hasUnsavedChanges = Object.values(state.hasChanges).some((change) => change)
    if (hasUnsavedChanges) {
        e.preventDefault()
        e.returnValue = 'You have unsaved changes! Are you sure you want to leave?'
    }
})
